import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {useTranslation} from "react-i18next";
import {cn} from "../utils/style";

const QRCodePayment = ({ paymentUrl, title, className = "hidden lg:block" }) => {
    const {t} = useTranslation();
    const displayTitle = title || t('pay.scan_to_pay');

    return (
        <div className={cn("bg-white rounded-lg border border-gray-200 p-4", className)}>
            <div className="text-center">
                <div className="mb-3">
                    <h4 className="text-sm font-semibold text-gray-800 mb-1">{displayTitle}</h4>
                    <p className="text-xs text-gray-600">
                        {t('pay.scan_qr_instruction')}
                    </p>
                </div>
                
                <div className="flex justify-center mb-3">
                    <div className="bg-white p-2 rounded-lg shadow-sm border border-gray-100">
                        <QRCodeSVG
                            value={paymentUrl}
                            size={120}
                            bgColor="#ffffff"
                            fgColor="#000000"
                            level="M"
                            includeMargin={false}
                        />
                    </div>
                </div>
                
                <div className="text-xs text-gray-500 space-y-1">
                    <div className="flex items-center justify-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                        </svg>
                        <span>{t('pay.mobile_friendly')}</span>
                    </div>
                    <div>{t('pay.scan_qr_camera')}</div>
                </div>
            </div>
        </div>
    );
};

export default QRCodePayment;